/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/ui/accordion'
import { cn } from '@/lib/utils'

type SettingsAccordionProps = {
  value: string
  title: string
  children: React.ReactNode
  className?: string
  keepMounted?: boolean
}

export function SettingsAccordion({
  value,
  title,
  children,
  className,
  keepMounted,
}: SettingsAccordionProps) {
  return (
    <AccordionItem value={value} className={cn(className)}>
      <AccordionTrigger className='hover:no-underline'>
        <div className='flex flex-col gap-1 text-left'>
          <div className='text-base font-semibold'>{title}</div>
        </div>
      </AccordionTrigger>
      <AccordionContent className='pt-4' keepMounted={keepMounted}>
        {children}
      </AccordionContent>
    </AccordionItem>
  )
}
